import { combineReducers } from 'redux';

import type { FormFieldMetadataStateMap } from '../../common-form/metaData/fields/fields.model';
import { fieldsReducer } from './fields/fields.reducer';

export type MetaDataState = Readonly<{
  fields: FormFieldMetadataStateMap;
}>;

export const metaDataReducer = combineReducers<MetaDataState>({
  fields: fieldsReducer,
});
